module.exports = __webpack_public_path__ + "img/agreement-summary.afa38a79.jpg";